import clx from 'classnames';

import styles from './IconButton.module.scss';
import { useRef } from 'react';
import { sendMessageToApp } from 'utils/exsternalCall';

const IconButton = ({
  size = '25px',
  padding = '5px',
  svg,
  onClick,
  type = 'default',
  value,
  isActive = true,
  background = '',
  margin = '0 0 0 0',
}) => {
  const fromApp = localStorage.getItem('fromApp') == 'true';

  const handleIconClick = (e) => {
    switch (type) {
      case 'default': {
        onClick();
        break;
      }
      case 'phone': {
        e.preventDefault();
        if (isActive) {
          if (!fromApp)
            window.location.href = `tel:${value.replaceAll(/\D/g, "")}`;
          else sendMessageToApp("app:phone", { number: `+${value.length > 9 ? value.replaceAll(/\D/g, "") : '39'+value.replaceAll(/\D/g, "")}` });

        }
        break;
      }
      case 'email': {
        e.preventDefault();
        if (isActive) {
          if (!fromApp)
            window.location.href = `mailto:${value}`;
          else sendMessageToApp("app:mail", { email: `${value}` });
        }
        break;
      }
      case 'whatsapp': {
        e.preventDefault();
        if (isActive) {
          const baseUrl = 'https://wa.me/'
          if (!fromApp)
            window?.open(`${baseUrl}${value.replaceAll(/\D/g, "")}`, '_blank');
          else sendMessageToApp("app:whatsapp", { number: `+${value.length > 9 ? value.replaceAll(/\D/g, "") : '39'+value.replaceAll(/\D/g, "")}`, text: 'Ciao' });
        }
        break;
      }
      case 'instagram': {
        e.preventDefault();
        const url = 'https://www.instagram.com/zetabarber.it/'
        if (isActive) {
          if (!fromApp)
            window.open(url, '_blank');
          else sendMessageToApp("app:url", {url});
        }
        break;
      }
    }
  };

  return (
    <button
      role='button'
      style={{
        height: size,
        width: size,
        padding,
        background,
        margin,
      }}
      className={styles.icon__btn}
      onClick={(e) => handleIconClick(e)}
      disabled={!isActive}
    >
      {svg}
    </button>
  );
};

export default IconButton;
